import { Breadcrumbs } from "../components/Breadcrumbs";

function Prestador() {
    return (
        <div>
            <Breadcrumbs currentPage="Prestadores" />
            <header className="page-header">
                <h2 className="page-title">Gestão de Prestadores</h2>
            </header>
            <div className="table-placeholder">
                Módulo de Prestadores em construção.
            </div>
        </div>
    );
}

export default Prestador;
